// extracted by mini-css-extract-plugin
export default {"item":"video_player_item__1Y0Ok","icon":"video_player_icon__atRJt","name":"video_player_name__tu5Sc","frameBox":"video_player_frameBox__KVgma"};